import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import styled from 'styled-components'

import { makeMainLayout } from '@/layouts/main'
import LandlordHeader from '@/features/Header/landlords-header'
import LandlordsPage from '@/features/Landlord'
import MainWrapper from '@/features/Structure/main-wrapper'
import Head from '@/components/head'

const Wrapper = styled(MainWrapper)`
  display: flex;
  flex-direction: column;
  overflow: hidden;
`

function Landlords() {
  const { t } = useTranslation('landlords')

  const metaTitle = t(
    'landlords:Landlord Productivity Tool | Landlords | liv.rent'
  )
  const metaDescription = t(
    'landlords:Your go-to landlord productivity tool to help you advertise listings, screen tenants, sign leases and get paid, all in one place.'
  )

  return (
    <>
      <Head title={metaTitle} description={metaDescription} path="/landlords" />
      <Wrapper>
        <LandlordsPage />
      </Wrapper>
    </>
  )
}

export const getStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['translation', 'landlords']))
    }
  }
}

const headerConfig = {
  showNavItems: true,
  showSearch: false,
  header: LandlordHeader,
  theme: 'transparent',
  logoStyle: 'black',
  headerNavStyle: 'black'
}

Landlords.Layout = makeMainLayout({ headerConfig })

export default Landlords
